import { g as n, a as c } from "./index-Dvb-FM3N.js";
import { C as d } from "./types-CtrTQJmy.js";
class f {
  constructor(o, e = []) {
    this.name = o, this.dependencies = e;
    const t = n.DriverTaskConfig.create({ noop: {} });
    this.config = n.DriverTaskConfig.encodeDelimited(t).finish();
  }
  config;
  enclaveType = "decentriq.driver";
  outputFormat = c.ComputeNodeFormat.RAW;
}
class r {
  constructor(o, e, t = []) {
    this.name = o, this.dependencies = t;
    const i = n.DriverTaskConfig.create({
      staticContent: {
        content: e
      }
    });
    this.config = n.DriverTaskConfig.encodeDelimited(
      i
    ).finish();
  }
  config;
  enclaveType = "decentriq.driver";
  outputFormat = c.ComputeNodeFormat.RAW;
  static create(o, e, t = []) {
    return new r(
      o,
      new TextEncoder().encode(e),
      t
    );
  }
}
class g extends d {
  decode(o) {
    const e = n.DriverTaskConfig.decodeDelimited(o), t = e.toJSON();
    if (e.staticContent?.content) {
      const i = new TextDecoder().decode(
        e.staticContent.content
      );
      t.staticContent.content = i;
    }
    return t;
  }
}
export {
  g as GcgDriverDecoder,
  f as Noop,
  r as StaticContent
};
//# sourceMappingURL=compute.js.map
